import { router } from "expo-router";

const goBack = (goToRoot?: boolean) => {
  const canGoBack = router.canGoBack();
  if (canGoBack && goToRoot !== true) {
    router.back();
  } else {
    router.replace("/");
  }
};

export default goBack;